<template>
  <div class="all-wrapper menu-side with-pattern" style="padding-top:20px">
    <router-view name="content"></router-view>
    <div class="app-version">ver {{ appVersion }}</div>
  </div>
</template>

<script>
import LoginForm from '@/pages/Login/LoginForm';
import ChangePasswordWrapper from '@/pages/Login/ChangePassword/Wrapper';
import Config from '@/config';

export default {
  components: {
    LoginForm,
    ChangePasswordWrapper,
  },
  computed: {
    appVersion() {
      return Config.version;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../assets/scss/mo-custom';
.app-version {
  max-width: 450px;
  margin: 0 auto;
  padding: 0 0.5rem;
  text-align: right;
  color: $mute-color;
  font-size: 0.8em;
}
</style>
